module.exports = __webpack_public_path__ + "static/img/downloadCode.7f47c7b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/downloadCode.png
// module id = Q6Di
// module chunks = 8 9